import DocumentEditor from './components/SeoMetatagEditor';
import DocumentPreview from './components/SeoMetatagPreview';
import contentHelpers from './SeoMetatag.getContent';
import Icon from './SeoMetatag.icon';

// search results page max numbers
const MAX_SERP_DESCRIPTION_CHARS = 160;
const MAX_SERP_TITLE_CHARS = 65;

const getWordCounts = (document) => {
  return [
    {
      title: 'Title',
      value: document.content[0],
      limit: MAX_SERP_TITLE_CHARS,
    },
    {
      title: 'Content',
      value: document.content[1],
      limit: MAX_SERP_DESCRIPTION_CHARS,
    },
  ];
};

export default {
  ...contentHelpers,
  DocumentEditor,
  DocumentPreview,
  Icon,
  getWordCounts,
};
